// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, useEffect, useState} from 'react';
import cn from 'classnames';
import {Settings_context} from '../../../../../hola/pub/settings_ctx';
import Icon_x from '../../../../../hola/pub/img/hola2023/icons/16/x_close.svg';
import Icon_dove from '../../../img/dove2.svg';
import {use_translation_v} from '../../../../../hola/pub/lib/trans_v';
import {Button, t_button_size} from '../../../../../shared/ui/button';
import {perr} from 'hola_pub_util';
import hola_opt from 'hola_opt';
import etask from 'zetask';
import {use_app_context} from '../../../lib/app_context';
import {find_order_by} from '../utils';
import date from '/util/date.js';
import {api} from '../../../lib/api';
import {Modal} from '../../../../../hola/pub/lib/modal';
import Icon_arrow_right from '../../../img/icons/24/arrow_up_right.svg';

import styles from './rate_us.module.less';

interface i_rate_us_props {
    rate_us_url: string;
    product_name: string;
    success_icon?: JSX.Element;
    btn_size?: t_button_size;
    ui_border?: boolean;
}

export const Rate_us =
({product_name, success_icon, btn_size, rate_us_url, ui_border}
  : i_rate_us_props)=>{
    const {theme} = useContext(Settings_context);
    const {T, t} = use_translation_v({no_defaults: true});
    const {dashboard} = use_app_context();
    const [modal, set_modal] = useState(false);
    const [leave_feedback_modal, set_leave_feedback_modal] = useState(false);
    const [feedback, set_feedback] = useState('');
    const [feedback_submitted, set_feedback_submitted] = useState(false);
    const [trustpilot_submitted, set_trustpilot_submitted] = useState(false);
    const {user} = hola_opt;
    const [rate, set_rate] = useState(user?.ui_state?.rate_us_rating);
    const [should_close, set_should_close] = useState(false);
    useEffect(()=>{
        if (feedback_submitted)
        {
            const feedback_success_timeout = setTimeout(()=>{
                set_should_close(true);
                set_feedback_submitted(false);
            }, 3000);
            return ()=>clearTimeout(feedback_success_timeout);
        }
    }, [feedback_submitted]);
    const yesterday = date.add(date(), {day: -1});
    const is_closed_recently = user?.ui_state?.rate_us_closed_ts &&
        date(user.ui_state.rate_us_closed_ts) > yesterday;
    const hide_rate_us = should_close || !user
            || user.ui_state?.rate_us_rating || is_closed_recently;
    if (hide_rate_us)
        return null;
    const days_3_ago = date.add(date(), {day: -3});
    const {orders, zone_groups} = dashboard?.info || {};
    const have_matched_orders = !!find_order_by({
        orders, zone_groups,
        find_fn: o=>!o.disabled &&
            date(o.start)<days_3_ago || o.usage_info?.used/o.limit>0.2
    });
    if (!have_matched_orders)
        return null;
    const save_rate = (v: number)=>{
        const {www_hola} = hola_opt;
        const email = user?.emails?.[0]?.value || '';
        perr({id: www_hola.site+'_rate_us', info: {rate: v, email}});
        api.update_user_ui_state({rate_us_rating: v});
        set_rate(v);
        if (v < 4)
            set_leave_feedback_modal(true);
        else
            set_trustpilot_submitted(true);
    };
    const close_rate_us = ()=>{
        api.update_user_ui_state({rate_us_closed_ts: date()});
        set_should_close(true);
    };
    const show_feedback_form = ()=>{
        set_leave_feedback_modal(false);
        set_modal(true);
    };
    const submit_feedback = ()=>{
        if (!feedback.trim())
            return;
        etask(function*(){
            const {www_hola} = hola_opt;
            const email = user?.emails?.[0]?.value || '';
            yield perr({
                id: www_hola.site + '_rate_us_feedback',
                info: {feedback, email}
            });
            set_feedback('');
            set_modal(false);
            set_feedback_submitted(true);
        });
    };
    return <div className={styles.rate_us_trustpilot}>
      <div className={cn(styles.close_btn, theme.color_n700)}
        onClick={close_rate_us}><Icon_x/></div>
      {!rate && <>
        <p className={cn(theme.p18, theme.med, theme.color_n700, styles.mb4)}>
          <T>Let us know what you think!</T></p>
        <span className={cn(theme.u4, theme.color_n500)}>
          <T>How would you rate {product_name}?</T></span>
        <div className={styles.ratings}>
          {Array.from({length: 5}, (_, i)=>
            <div key={i+1} id={i+1+''} className={styles.rating}
              onClick={()=>save_rate(i+1)}>
              {i+1}
            </div>)}
        </div>
        <div className={styles.rating_range}>
          <p className={cn(theme.p12)}><T>Not so good</T></p>
          <p className={cn(theme.p12)}><T>Excellent</T></p>
        </div>
      </>}
      {rate && rate < 4 && leave_feedback_modal && !modal &&
        !feedback_submitted && !trustpilot_submitted &&
        <>
          <p className={cn(theme.p18, theme.med, theme.color_n700)}>
            <T>How can we improve?</T></p>
          <span>Tell us a bit more about it</span>
          <div className={styles.feedback_block}>
            <Button caption='Close' color='secondary'
              size={btn_size ?? 'xs'}
              on_click={close_rate_us} />
            <Button caption={t('Leave a feedback')}
              size={btn_size ?? 'xs'}
              on_click={show_feedback_form} />
          </div>
        </>
      }
      {rate && rate >= 4 && trustpilot_submitted && !should_close && <>
        <p className={cn(theme.p18, theme.med, theme.color_n700, styles.mb8)}>
          <T>Wow, thank you! &#x1F60D;</T></p>
        <p className={cn(theme.color_n600, theme.p14, styles.tp_text)}>
          <T>Wanna give us a quick review on Trustpilot?</T></p>
        <div className={styles.rate_five_btns}>
          <Button caption={t('Maybe next time')} color='secondary' fit
            size={btn_size ?? 'xs'} on_click={close_rate_us}/>
          <Button caption={t('Take me there')} size={btn_size ?? 'xs'}
            to={rate_us_url} as_external target='_blank'
            on_click={()=>{
              const {www_hola} = hola_opt;
              const email = user?.emails?.[0]?.value || '';
              perr({id: www_hola.site+'_rate_us_goto_trustpilot',
                info: {rate, email}});
              close_rate_us();
            }}/>
        </div>
      </>}
      <Modal
        lighter_close_btn={true}
        paddingless={true}
        width={640}
        cls={styles.modal}
        is_open={!!modal}
        on_close={()=>set_modal(false)}
        on_overlay_click={()=>set_modal(false)}>
          <div className={styles.modal_content}>
            <p className={cn(theme.p20, theme.bold, theme.color_n700)}>
              <T>How can we improve?</T>
            </p>
            <span className={cn(theme.p14, theme.color_n700,
              styles.description)}>Description</span>
            <textarea
              className={cn(theme.p14, theme.med, theme.color_n700,
                styles.textarea, ui_border && styles.ui_border)}
              placeholder={t('Tell us a bit more about it')}
              value={feedback}
              onChange={e=>set_feedback(e.target.value)}
            />
            <Button
              caption={t('Submit')}
              disabled={!feedback.trim()}
              on_click={submit_feedback}
              size='md'
              cls={styles.btn}
              icon_right={<Icon_arrow_right/>}
            />
          </div>
      </Modal>
      {feedback_submitted && <>
        <p className={cn(theme.p18, theme.med, theme.color_n700,
          styles.feedback_thanks_msg)}><T>Thanks for the feedback!</T></p>
        <div className={styles.icon}>{success_icon ?? <Icon_dove />}</div>
      </>}
    </div>;
};
